/* eslint-disable max-len */
import React, {
  useEffect, useState, ChangeEvent, MouseEvent, KeyboardEvent,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, IconButton, InputBase } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import posthog from 'posthog-js';
import { ellipsis } from 'polished';

import Color from '@tool/color';
import moHeader, {
  changeValue, changeJobname,
} from './store/index';
import {
  SearchIcon, IconX1, IconX2, IconX3, IconX4, IconX5, VPlay,
  EffectIcon55, DashboardIcon,
} from '@styled/icon';
import AdSlick from './ad-slick';
import moUser from '@store/user';
import moSkin from '@store/skin';
import moHome, { setUrl, toggleOpen } from '@store/home';

interface IProps {}
interface IState {}

const DInput = styled(InputBase)(() => ({
  width: '390px',
  height: '36px',
  padding: '0 0 0 10px',
  borderBottom: 'none',
  borderRadius: '5px',
  border: `1px solid ${Color.ec}`,
  backgroundColor: Color.fff,

  '& input': {
    padding: 0,
    fontSize: '12px',
    fontWeight: 500,
    color: Color.c55,
  },
  '& input::placeholder': {
    opacity: 1,
    color: Color.cf,
  },
}));

const DIconButton = styled(IconButton)(() => ({
  padding: '6px 10px',
  borderRadius: 0,
  '&:hover': { backgroundColor: Color.blackColor(0) },
}));

const DButton = styled(Button)(() => ({
  height: '36px',
  padding: '0 8px',
  marginLeft: '10px',
  marginBottom: '5px',
  fontSize: '12px',
  fontWeight: 500,
  borderRadius: '5px',
  color: Color.c55,
  backgroundColor: Color.primaryColor(0.1),

  '&:hover': { backgroundColor: Color.primaryColor(0.1) },
}));

{/** 市场人才数据 */}
const PopMarket = (props: IProps, state: IState) => {
  const { reportCount, isLogin, isReportExpired } = moUser;
  const navi = useNavigate();
  const { popMarket, jobname, subJobList } = moHeader;
  const { modules, partner } = moSkin;
  const list = [
    {
      imageUrl: 'https://file.smartsalary.cn/web-img%402.0/home/nav003.png',
      toUrl: '/market/insight',
    },
  ];

  useEffect(() => {
    return () => {};
  }, []);

  const onQuery = (ev?: MouseEvent) => {
    ev?.stopPropagation();
    posthog.capture('导航市场薪酬查询人数', {});
    if (isEmpty(jobname)) {
      let newJob = '';
      if (!isEmpty(subJobList)) newJob = subJobList[0].job_name || '';

      if (!newJob) {
        changeJobname('');
        localStorage.setItem('jobname', '');
        window.location.href = '/market/marketpay';
      } else {
        changeJobname('');
        localStorage.setItem('jobname', newJob);
        window.location.href = '/market/result';
      }
    } else {
      changeJobname('');
      localStorage.setItem('jobname', jobname);
      window.location.href = '/market/result';
    }
  };

  const onPress = (ev: KeyboardEvent) => {
    ev.stopPropagation();
    posthog.capture('导航市场薪酬查询人数', {});
    if (ev.key === 'Enter') onQuery();
  };

  // 政策数据
  const onJumpMacro = () => {
    posthog.capture('导航政策数据点击人数', {});
    window.location.href = '/market/macro';
  };

  // 市场人才数据首页
  const onJumpDashboard = () => {
    posthog.capture('导航市场人才数据首页点击人数', {});
    window.location.href = '/dashboard';
  };

  // 对标企业招聘动态
  const onJumpInsight = () => {
    posthog.capture('导航对标企业招聘动态点击人数', {});
    window.location.href = '/market/insight';
  };

  // 人效
  const onEffect = () => {
    posthog.capture('导航人效点击人数', {});
    window.location.href = '/effect';
  };

  // 人力核心指标
  const onJumpMarket = () => {
    posthog.capture('导航人力核心指标点击人数', {});
    window.location.href = '/market';
  };

  // 职位薪酬
  const onJumpMarketpay = () => {
    posthog.capture('导航职位薪酬点击人数', {});
    window.location.href = '/market/marketpay';
  };

  // 定制薪酬报告
  const onJumpCustomreport = () => {
    posthog.capture('导航定制薪酬报告点击人数', {});
    if (isLogin && reportCount > 0 && !isReportExpired) {
      window.location.href = '/customreport';
    } else {
      window.location.href = '/home/customreport';
    }
  };

  // 离职率
  const onLeaveRate = () => {
    // posthog.capture('顶部导航栏跳转-离职率', {});
    window.location.href = '/index/human-indicator/2';
  };

  // 员工调薪率
  const onAjustSalary = () => {
    // posthog.capture('顶部导航栏跳转-员工调薪率', {});
    window.location.href = '/index/human-demand/1';
  };

  // 政府政策数据
  const onPolicyData = () => {
    // posthog.capture('顶部导航栏跳转-政府政策数据', {});
    window.location.href = '/market/macro';
  };

  // 点击热门职位
  const onHotJob = (value: string) => {
    // posthog.capture(`顶部导航栏跳转-${value}`, {});
    changeJobname('');
    localStorage.setItem('jobname', value);
    window.location.href = '/market/result';
  };

  // 播放视频
  const onPlay = () => {
    changeValue('popMarket', false);
    setUrl('https://file.smartsalary.cn/v2-video/%E6%98%93%E8%B7%AF%E8%81%8C%E5%9C%BA%E7%94%A8%E8%96%AA%E8%AF%B4-%E7%AC%AC%E4%B8%80%E6%9C%9F01_%E7%AC%AC%E4%B8%80%E8%8A%82.mp4');
    toggleOpen(true);
  };

  return (
    <section aria-hidden="true" className="header-pop_100"
      onMouseEnter={() => changeValue('popMarket', true)}
      onMouseLeave={() => changeValue('popMarket', false)}>
      <section className="pop-1010">
        <section className="pop-box_100">
          <i className="tri-10 tri-11" />
          <section className="box-10">
            <section className="search-11">
              <DInput value={jobname}
                endAdornment={(
                  <DIconButton onClick={onQuery}>
                    <SearchIcon color={Color.primary} />
                  </DIconButton>
                )}
                onChange={(ev: ChangeEvent<HTMLInputElement>) => changeJobname(ev.target.value)}
                onKeyPress={onPress}
                placeholder="请输入职位名称搜索" />
              <section className="search-101">
                {!isEmpty(subJobList) ? (
                  <DButton onClick={() => onHotJob(subJobList[0]?.job_name)}>
                    {subJobList[0]?.job_name}
                  </DButton>
                ) : null}
                <DButton onClick={onLeaveRate}>离职率</DButton>
                <DButton onClick={onAjustSalary}>员工调薪率</DButton>
                <DButton onClick={onPolicyData}>政府政策数据</DButton>
              </section>
            </section>
            <section className="card-11">
              {modules.includes('dashboard') ? (
                <section className="card-101" aria-hidden="true" onClick={onJumpDashboard}
                  data-attr="ph-capture" data-custom-id="market01">
                  <p className="line-101">
                    <DashboardIcon />
                    <b className={partner === 'smartsalary' ? 'primary-111' : 'black-111'}>数据中心</b>
                  </p>
                  <span style={{ ...ellipsis('100%', 2) }}>市场人才数据概览</span>
                </section>
              ) : null}
              {modules.includes('rivalCompany') ? (
                <section className="card-101" aria-hidden="true" onClick={onJumpInsight}
                  data-attr="ph-capture" data-custom-id="market01">
                  <p className="line-101">
                    <IconX1 />
                    <b className={partner === 'smartsalary' ? 'primary-111' : 'black-111'}>对标企业招聘动态</b>
                  </p>
                  <span style={{ ...ellipsis('100%', 2) }}>
                    竞品分析报告：招聘动向分析、人才需求分析、薪酬趋势分析
                  </span>
                </section>
              ) : null}
              {modules.includes('efficiency') ? (
                <section className="card-101" aria-hidden="true" onClick={onEffect}
                  data-attr="ph-capture" data-custom-id="market02">
                  <p className="line-101">
                    <EffectIcon55 />
                    <b className={partner === 'smartsalary' ? 'primary-111' : 'black-111'}>人效</b>
                  </p>
                  <span style={{ ...ellipsis('100%', 2) }}>
                    人效、薪酬投入、人员配置、支持效能
                  </span>
                </section>
              ) : null}
              {modules.includes('HRIndicator') ? (
                <section className="card-101" aria-hidden="true" onClick={onJumpMarket}
                  data-attr="ph-capture" data-custom-id="market03">
                  <p className="line-101">
                    <IconX2 />
                    <b className={partner === 'smartsalary' ? 'primary-111' : 'black-111'}>人力核心指标</b>
                  </p>
                  <span style={{ ...ellipsis('100%', 2) }}>
                    市场规模、招聘趋势、离职率、涨薪率、弹性福利
                  </span>
                </section>
              ) : null}
              {modules.includes('policyData') ? (
                <section className="card-101" aria-hidden="true" onClick={onJumpMacro}
                  data-attr="ph-capture" data-custom-id="market04">
                  <p className="line-101">
                    <IconX3 />
                    <b className={partner === 'smartsalary' ? 'primary-111' : 'black-111'}>政策数据</b>
                  </p>
                  <span style={{ ...ellipsis('100%', 2) }}>
                  社保公积金缴纳基数、操作实务、工资收入、法定福利
                  </span>
                </section>
              ) : null}
              {modules.includes('jobSalary') ? (
                <section className="card-101" aria-hidden="true" onClick={onJumpMarketpay}
                  data-attr="ph-capture" data-custom-id="market05">
                  <p className="line-101">
                    <IconX4 />
                    <b className={partner === 'smartsalary' ? 'primary-111' : 'black-111'}>职位薪酬</b>
                  </p>
                  <span style={{ ...ellipsis('100%', 2) }}>
                    3000+基准职位、数百细分行业、国内大中城市全覆盖
                  </span>
                </section>
              ) : null}
              {modules.includes('customReport') ? (
                <section className="card-101" aria-hidden="true" onClick={onJumpCustomreport}
                  data-attr="ph-capture" data-custom-id="market06">
                  <p className="line-101">
                    <IconX5 />
                    <b className={partner === 'smartsalary' ? 'primary-111' : 'black-111'}>定制薪酬报告</b>
                  </p>
                  <span style={{ ...ellipsis('100%', 2) }}>
                    百万企业满足细分行业竞品对标，多部门协同快速交付
                  </span>
                </section>
              ) : null}
            </section>
          </section>

          {modules.includes('video') ? (
            <section className="box-20">
              <section className="box-21">
                <AdSlick list={list} />
              </section>
              <section className="box-22">
                <p className="title-1122">互联网在人才吸引和保留上做对了什么？</p>
                <p className="img-11220" aria-hidden="true" onClick={onPlay}>
                  <img src="https://file.smartsalary.cn/web-img%402.0/home/v-market.png"
                    alt="cover" className="img-1122" />
                  <VPlay />
                </p>
              </section>
            </section>
          ) : null}

        </section>
      </section>
    </section>
  );
};

export default observer(PopMarket);
